import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { WhatIfToolDetailModel } from '../../Models/Models/Processes/WhatIfTool/WhatIfToolDetailModel';

declare var IS_RUNNING_IN_APP_POOL;

export class WhatIfToolInstructionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(subAccountHierarchyId: string, headAccountHierarchyId: string, batchId: number): Promise<WhatIfToolDetailModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/WhatIfToolInstruction/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { subAccountHierarchyId: subAccountHierarchyId, headAccountHierarchyId: headAccountHierarchyId, batchId: batchId }

    return AjaxWrapper.get<WhatIfToolDetailModel, any>(url, data);
  }
  public put(hierarchyId: string): Promise<string, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/WhatIfToolInstruction/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId }

    return AjaxWrapper.put<string, any>(url, data);
  }
}

